import { useEffect, useState } from 'react';
import _reduce from 'lodash/reduce';
import _isEmpty from 'lodash/isEmpty';
import { useLifeCycleEventBus } from '@thd-olt-functional/utils';
import { useProductDataStore, usePromoStore } from '../store';
import { useDesignStore } from '../store/design/context';

export default () => {
  const [promoProducts, setPromoProducts] = useState([]);
  const productData = useProductDataStore((state) => state.productData);
  const { products, cart } = useDesignStore((state) => state.design);
  // const products = useDesignStore((state) => state.design.products);
  // const cart = useDesignStore((state) => state.design.cart);
  const updateProductsWithRewardTiers = usePromoStore((state) => state.updateProductsWithRewardTiers);
  const promoData = useLifeCycleEventBus('promotion-products.items-to-add-to-cart');

  useEffect(() => {
    if (!_isEmpty(productData)) {
      const allProductsWithTiers = _reduce([...products, ...cart], (prev, curr) => {
        const productPricing = productData?.[curr.Sku]?.pricing;
        const productWithTier = {
          itemId: Number(curr.Sku),
          promoRewardTiers: productPricing?.conditionalPromotions?.[0]?.reward?.tiers,
          selected: true,
          price: productPricing?.value,
          quantity: curr.Quantity
        };
        return ([...prev, productWithTier]);
      }, []);
      updateProductsWithRewardTiers(allProductsWithTiers);
      return setPromoProducts(allProductsWithTiers);
    }
    return setPromoProducts([]);
  }, [productData, products, cart, promoData]);

  return [promoProducts, setPromoProducts];
};
